import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  constructor(public http: HttpClient, 
    public auth: AuthService) { }

  buscarTodosClientes(Parametro) {
    return new Promise((resolve, reject) => {
      this.http.post(this.auth.URL + '/consultaTodosClientes', Parametro)
        .subscribe((result: any) => {
          if(result._body != ""){
            resolve(result);
          }
        },
        (error) => {
          reject(error);
        });
    });
  }

  buscarClienteIndividual(Parametro) {
    return new Promise((resolve, reject) => {
      this.http.post(this.auth.URL + '/consultaClienteCpf', Parametro)
        .subscribe((result: any) => {
          if(result._body != ""){
            resolve(result);
          }
        },
        (error) => {
          reject(error);
        });
    });
  }
  

  inserirClienteIndividual(Parametro) {
    return new Promise((resolve, reject) => {
      this.http.post(this.auth.URL + '/saveCliente', Parametro)
        .subscribe((result: any) => {
          if(result._body != ""){
            resolve(result);
          }
        },
        (error) => {
          reject(error);
        });
    });
  }

  atualizarVendaCliente(Parametro) {
    return new Promise((resolve, reject) => {
      this.http.post(this.auth.URL + '/atualizarVendaCliente', Parametro)
        .subscribe((result: any) => {
          if(result._body != ""){
            resolve(result);
          }
        },
        (error) => {
          reject(error);
        });
    });
  }

  consultarClienteWebServices(parametro){
    return new Promise((resolve, reject) => {
      this.http.post(this.auth.URL + '/consultarCNPJ', parametro)
        .subscribe((result: any) => {
          if(result._body != ""){
            resolve(result);            
          }
        },
        (error) => {
          reject(error);
        });
    });
  }
}
